import { useParams } from 'react-router';
import { IRouteParamsBase } from '../../models';

export const useGetEwpRoute = (route: string): string => {
  const { orgId, id } = useParams<IRouteParamsBase>();
  return route.replace(':orgId', orgId).replace(':id', id);
};
